import apiRequest from '../../../http/api-request'
import authService from '@/auth/authService'

export default {
  fetchCharities({commit}) {

    return new Promise((resolve, reject) => {
      apiRequest.doGetRequest(`/client/charities`, {}, {'X-Harness-JWT': authService.getToken()}, {skipCache: true})
        .then((charities) => {
          commit('SET_CHARITIES', charities)
          resolve(charities)
        })
        .catch((error) => reject(error))
    })
  },
  async fetchCharityConfig({commit}, {charityId}) {
    try {
      const response = await apiRequest.doGetRequest(`/whitelabel/${charityId}/config`)
      commit('SET_ACTIVE_CHARITY_INFO', response)
      return response
    } catch (error) {
      if (error?.response?.status === 404) {
        return null
      }
      throw error
    }
  },
}
